export enum DeductionDisabilityCareTaker {
  APPLICANT = 1,
  SPOUSE = 2,
  APPLICANT_AND_SPOUSE = 3,
}
